import { Checkbox as MuiCheckbox, CheckboxProps as MuiCheckboxProps, styled } from '@mui/material'
import React from 'react'

export type CustomCheckboxProps = Omit<MuiCheckboxProps, 'disabledTouchRipple' | 'disableFocusRipple' | 'disableRipple'> & {
  //
}

export const Checkbox: React.FC<CustomCheckboxProps> = (props) => {
  return (
    <StyledCheckbox
      disableTouchRipple
      disableFocusRipple
      disableRipple
      {...props}
    />
  )
}

const StyledCheckbox = styled(MuiCheckbox)`

`